import React, { createContext, useContext } from 'react';

const CurrentTeamIdContext = createContext(null);

export const useCurrentTeamIdContext = () => {
    const context = useContext(CurrentTeamIdContext);
    if (context === undefined) {
        throw new Error('useCurrentTeamIdContext must be used within a CurrentTeamIdProvider');
    }
    return context;
};

export const CurrentTeamIdProvider = CurrentTeamIdContext.Provider;